// @flow
'use strict';

import * as React from 'react';

import type { IEmitente } from '../types';

import RowDetalhes from '../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../common/detalhes_documento/column_detalhes';
import Endereco from './endereco';

type EmitenteProps = {
  emitente : IEmitente,
};

export default function Emitente({ emitente } : EmitenteProps) {
  return (
      <div className="tab-pane active">
        <h3>Emitente</h3>
        <RowDetalhes data={ emitente }>
          <ColumnDetalhes field="nome" type="documento" width="50%">Nome / Razão Social</ColumnDetalhes>
          <ColumnDetalhes field="fantasia" width="50%">Nome Fantasia</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ emitente }>
          <ColumnDetalhes field="cnpj" type="documento" width="50%">CNPJ</ColumnDetalhes>
          <ColumnDetalhes field="inscricaoEstadual" width="50%">Inscrição Estadual</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ emitente }>
          <ColumnDetalhes field="inscricaoMunicipal" width="50%">Inscrição Municipal</ColumnDetalhes>
          <ColumnDetalhes field="cnae" width="50%">CNAE Fiscal</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ emitente }>
          <ColumnDetalhes field="codigoRegimeTributario" width="50%">Código de Regime Tributário</ColumnDetalhes>
        </RowDetalhes>

        { emitente && <Endereco endereco={ emitente.endereco }/> }
      </div>
  );
}